<template>
	<div
		class="modal"
		data-backdrop="static"
		id="activityDetail"
		role="dialog"
		tabindex="-1"
		aria-labelledby="addCampaignGroup"
		aria-hidden="true"
	>
		<div class="modal-dialog modal-xl" role="document">
			<div class="modal-content campaign-g-addedit" style="min-height:350px">
				<div>
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLongTitle">Detail Page</h5>
						<button type="button" @click="reset" class="close" data-dismiss="modal">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>

					<div class="modal-body" style="min-height:200px;overflow:auto">
							<div v-if="dataType=='query'" >
								<p>{{data}}</p>
							</div>
								<div v-if="dataType=='rowData'" class="row table_wrap" style="height: 500px;">
									<table class="table">
										<thead>
											<tr>
												<th>&nbsp;</th>
												<th>Data</th>
												<th>Old value</th>
												<th>Updated value</th>
												<th></th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(item,index) in dataList" :key="index" :class="index%2==0?'even':''">
												<td></td>
												<td>{{item}}</td>
												<td>{{data[item] ?( data[item] == 't'? 'True':(data[item] == 'f' ? 'False' :data[item]) ): 'Not Set'}}</td>
												<td v-if="modifiedData && modifiedData.hasOwnProperty(item)" v-bind:style="modifiedData[item] && (modifiedData[item]!= data[item]) ? 'color:red' : 'color:black'">{{modifiedData[item] ? modifiedData[item] : 'Not Set'}}</td>
												<td v-else style="color:orange">Not Updated</td>
											</tr>
										</tbody>
									</table>
								<!-- <div class="col-md-6 row" v-for="(item,index) in dataList" :key="index">
									<div class="col-md-5" style="padding:0px">{{item + ':'}}</div>
									<div class="col-md-7" >
										<p style="color:orange;margin:0px">{{data[item] ?( data[item] == 't'? 'True':(data[item] == 'f' ? 'False' :data[item]) ): 'Not Set'}}</p>
										<span v-if="modifiedData[item] != undefined"  style="color:green">{{modifiedData[item]}}</span>
									</div>
								</div> -->
							</div>
					</div>
					<div class="modal-footer">
						<button class="btn btn-secondary" v-on:click="reset" data-dismiss="modal">Cancel</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "ActivityDetailMpdal",
		props: ["modifiedData", "data", "dataType"],
		data() {
			return {
				dataList: [],
			};
		},
		mounted() {
			this.props;
			if (this.dataType == "rowData") {
				Object.keys(this.data).forEach(this.rowDataFilter);
			} else {
				this.dataList.push(this.data);
			}
		},
		methods: {
			reset() {
				this.$emit("hideActivityDetailModal");
			},
			rowDataFilter(key) {
				this.dataList.push(key);
			}
		}
	};
</script>
